var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"aria-role":"list","position":_vm.dropdownPosition},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('b-button',{attrs:{"type":"is-info"},on:{"click":_vm.calculateDropdownPosition}},[_vm._v("View")])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }